import { render, staticRenderFns } from "./stockLimitAction.vue?vue&type=template&id=53ab8a48&scoped=true"
import script from "./stockLimitAction.vue?vue&type=script&lang=js"
export * from "./stockLimitAction.vue?vue&type=script&lang=js"
import style0 from "./stockLimitAction.vue?vue&type=style&index=0&id=53ab8a48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ab8a48",
  null
  
)

export default component.exports